export const AppName="ASAP UAE";
export const AppSlogon="Health Care Consultant";

export const tokenBeaer="Token"

export const mapConfig = "pk.eyJ1IjoiZGV2bWluaW1hbCIsImEiOiJja2s1YTV5bXkxc3luMnZwY3ZkNHRyZ2E4In0.wsgLsAl-3Sd1PaLy-lA6vA"; 
// export const mapConfig =  process.env.REACT_APP_MAP_MAPBOX;